export default __webpack_public_path__ + "static/media/oregonFull.53456ab6.jpg";